function ResetConfirmModal({ isOpen, onClose, onConfirm }) {
  return (
    <div
      className={`start-over-confirm fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-6 rounded-xl z-1001 w-72 text-center ${
        isOpen ? '' : 'hidden'
      }`}
    >
      <button
        id="reset-closed"
        className="absolute top-3 right-3 cursor-pointer"
        type="button"
        onClick={onClose}
      >
        ✕
      </button>
      <h3 className="text-lg font-bold">Start Over?</h3>
      <p>Are you sure you want to reset your customization?</p>
      <div className="flex justify-between mt-4">
        <button
          type="button"
          id="close-confirm"
          className="px-4 py-2 bg-gray-200 border border-gray-300 rounded-md cursor-pointer"
          onClick={onClose}
        >
          Cancel
        </button>
        <button
          type="button"
          id="start-confirm"
          className="px-4 py-2 bg-red-500 text-white border border-red-500 rounded-md cursor-pointer"
          onClick={onConfirm}
        >
          Reset
        </button>
      </div>
    </div>
  );
}

export { ResetConfirmModal };
